import React from "react";

const Impresion = () => {
  return <div>Impresion</div>;
};

export default Impresion;
